import React, { useState, useEffect } from 'react';
import Snowfall from 'react-snowfall'
import { newsletterApi } from '../../services/api';
import logger from '../../utils/logger';
import './ComingSoon.css';

const ComingSoon = ({ countdownDate: propCountdownDate }) => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });

  // Get countdown date from prop, env variable, or default
  const countdownDate = propCountdownDate || process.env.REACT_APP_COUNTDOWN_DATE || '2025-12-31T23:59:59';

  useEffect(() => {
    const calculateTimeLeft = () => {
      const difference = +new Date(countdownDate) - +new Date();

      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60),
        });
      } else {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      }
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, [countdownDate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      await newsletterApi.subscribeNewsletter(email);
      setSubmitted(true);
      setEmail('');
      setTimeout(() => setSubmitted(false), 5000);
    } catch (err) {
      logger.error('Failed to subscribe to newsletter from coming soon page', err);
      setError(err.message || 'Failed to subscribe. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (

      <main className="coming-soon-main">
        <Snowfall color='#F2784B' /> 
        <div className="coming-soon-wrapper">
          {/* Decorative shapes */}
          <div className="coming-soon-shapes">
            <div className="shape shape-1"></div>
            <div className="shape shape-2"></div>
            <div className="shape shape-3"></div>
            <div className="shape shape-4"></div>
            <div className="shape shape-5"></div>
            <div className="shape shape-6"></div>
          </div>

          <div className="container">
            <div className="row align-items-center">
              <div className="col-xl-5 col-lg-6 col-md-6">
                {/* Image/Logo Section */}
                <div className="coming-soon-img-wrapper">
                  <img 
                    src="/assets/images/logo.png" 
                    alt="LUMO Logo" 
                    className="coming-soon-logo"
                  />
                </div>
              </div>

              <div className="col-xl-7 col-lg-6 col-md-6">
                <div className="coming-soon-content">
                  <h1 className="coming-soon-title">Coming Soon</h1>
                  <p className="coming-soon-description">
                    Something amazing is on the way! We're working hard to bring you 
                    an exceptional experience. Stay tuned and be the first to know when we launch.
                  </p>

                  {/* Countdown */}
                  <div className="coming-soon-countdown">
                    <div className="countdown-item">
                      <div className="countdown-value">{String(timeLeft.days).padStart(2, '0')}</div>
                      <div className="countdown-label">Days</div>
                    </div>
                    <div className="countdown-separator">:</div>
                    <div className="countdown-item">
                      <div className="countdown-value">{String(timeLeft.hours).padStart(2, '0')}</div>
                      <div className="countdown-label">Hours</div>
                    </div>
                    <div className="countdown-separator">:</div>
                    <div className="countdown-item">
                      <div className="countdown-value">{String(timeLeft.minutes).padStart(2, '0')}</div>
                      <div className="countdown-label">Minutes</div>
                    </div>
                    <div className="countdown-separator">:</div>
                    <div className="countdown-item">
                      <div className="countdown-value">{String(timeLeft.seconds).padStart(2, '0')}</div>
                      <div className="countdown-label">Seconds</div>
                    </div>
                  </div>

                  {/* Newsletter Subscription Form */}
                  <form 
                    className="coming-soon-form"
                    onSubmit={handleSubmit}
                  >
                    <div className="form-group">
                      <input
                        type="email"
                        name="email"
                        className="form-input"
                        placeholder="Enter your email address"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        disabled={loading}
                      />
                      <button 
                        type="submit" 
                        className="submit-btn"
                        disabled={loading || !email.trim()}
                      >
                        {loading ? 'Subscribing...' : 'Notify Me'}
                      </button>
                    </div>
                    
                    {submitted && (
                      <div className="form-message success">
                        Thank you! We'll notify you when we launch.
                      </div>
                    )}
                    
                    {error && (
                      <div className="form-message error">
                        {error}
                      </div>
                    )}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
  );
};

export default ComingSoon;

